// src/components/BookCover/CanvasContextMenu.jsx
import React, { useEffect, useRef } from 'react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import '../../styles/CollaboratePanel.css';

/**
 * Props:
 *  - x, y         — viewport px position (from contextmenu event)
 *  - fabricObj    — the Fabric object that was right-clicked
 *  - commentCount — number of existing comments on this object
 *  - onComment    — (fabricObj) => void
 *  - onClose      — () => void
 */
export default function CanvasContextMenu({ x, y, fabricObj, commentCount = 0, onComment, onClose }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleDown = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) onClose();
    };
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', handleDown);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleDown);
      document.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  if (!fabricObj) return null;

  return (
    <div
      ref={menuRef}
      className="canvas-ctx-menu"
      style={{ left: x, top: y }}
    >
      <button
        className="canvas-ctx-item"
        onClick={() => { onComment(fabricObj); onClose(); }}
      >
        <ChatBubbleOutlineIcon style={{ fontSize: 14 }} />
        {commentCount > 0
          ? `Print Specifications (${commentCount})`
          : 'Add Print Specification'}
      </button>
    </div>
  );
}
